import { useTable } from "react-table";
import { useContext, useMemo, useState } from "react";
import primaryComponents from "../../../primaryComponents";
import { defaultDateDisplay } from "../../../../helpers";
import { useDeleteExpenseDepartmentMutation } from "../../../../hooks/api/mutations/expenses";
import { ToastContext } from "../../../../hooks/context";

export const useExpenseDepartmentsTable = ({ expenseDepartments = [] }) => {
  const [isEditDepartment, setIsEditDepartment] = useState(null);
  const [isDeleteDepartment, setIsDeleteDepartment] = useState(null);
  const triggerToast = useContext(ToastContext);

  const columns = useMemo(
    () => [
      {
        Header: "Department Name",
        accessor: "name",
      },
      {
        Header: "Created On",
        accessor: "created_at",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "Last Update On",
        accessor: "update_at",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <span className="d-flex align-items-center" style={{ gap: "10px" }}>
            <primaryComponents.Button
              classNames={"btn btn--primary smallBtn"}
              onClick={() => {
                setIsEditDepartment(row?.original);
              }}
            >
              Update
            </primaryComponents.Button>
            <primaryComponents.Button
              onClick={() => {
                setIsDeleteDepartment(row?.original);
              }}
              classNames={"btn btn--outline-red smallBtn"}
            >
              Delete
            </primaryComponents.Button>
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: expenseDepartments });

  const { mutate: deleteDepartment, isLoading: isDeletingDepartment } =
    useDeleteExpenseDepartmentMutation();

  const handleDeleteDepartment = () => {
    deleteDepartment(
      { id: isDeleteDepartment?.id },
      {
        onSuccess: () => {
          triggerToast(
            `Department: ${isDeleteDepartment?.name} deleted successfully`,
            "success",
          );
          setIsDeleteDepartment(null);
        },
      },
    );
  };

  return {
    instance,
    isDeleteDepartment,
    isEditDepartment,
    isDeletingDepartment,
    setIsDeleteDepartment,
    setIsEditDepartment,
    handleDeleteDepartment,
  };
};
